import { Routes } from '@angular/router';

export const publicRoutes: Routes = [
  {
    path: 'privacy-notice',
    data: {
      breadcrumb: () => $localize`:@@general.privacyPolicy:Datenschutzerklärung`,
    },
    loadComponent: () => import('./privacy-notice/privacy-notice.page').then((c) => c.PrivacyNoticePage),
  },
  {
    path: 'imprint',
    data: {
      breadcrumb: () => $localize`:@@general.legalNotice:Impressum`,
    },
    loadComponent: () => import('./imprint/imprint.page').then((c) => c.ImprintPage),
  },
  {
    path: 'licenses',
    loadComponent: () => import('./licenses/third-party-licenses.page').then((c) => c.ThirdPartyLicensesPage),
  },
];
